<template lang="html">
	<div id="app" class="main column no-header">
		<div class="background-login"></div>
		<div class="active login">
			<img src="~@/common/assets/img/logo-patrim.svg" alt="">
			<form class="form-ui column" novalidate v-on:keyup.enter="connect">
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('username')}">
					<label for="email">Votre pseudo</label>
					<input v-validate="'required'" type="text" name="username" v-model="username">
				</div>
				<div v-if="errors.has('username')" class="error-message">{{ errors.first('username') }}</div>
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('password')}">
					<label for="password">Mot de passe</label>
					<input v-validate="'required'" type="password" name="password" v-model="password">
				</div>
				<div v-if="errors.has('password')" class="error-message">{{ errors.first('password') }}</div>
			</form>
			<div class="ctn-connect">
				<div class="light btn btn-black" @click="connect">
					Connexion anonyme
				</div>
			</div>
			<router-link class="ctn-password-reset link" :to="{name: 'AnonymousSubscribe'}">
				Vous n'avez pas de compte anonyme ? Vous inscrire
			</router-link>
			<router-link class="ctn-password-reset link" :to="{name: 'Login'}">
				Connexion (classique)
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AnonymousLogin',
	data () {
		return {
			username: null,
			password: null
		}
	},
	methods: {
		connect () {
			this.$validator.validate().then((validation) => {
				if (validation) {
					this.$store.commit('LOADER_IN')
					this.$store.dispatch('anonymousLogin', {
						email: this.username,
						password: this.password
					}).then(() => {
						this.$store.commit('LOADER_OUT')
						this.$router.push({ name: 'Main' })
					}).catch((error) => {
						this.$store.commit('LOADER_OUT')
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Connexion',
							text: error.message
						})
					})
				}
			})
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Auth/AnonymousLogin.vue